import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayoutLeftFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 12",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33333 0V12H1.33333C0.630425 12 0.0545566 11.4561 0.00365718 10.7662L0 10.6667V1.33333C0 0.630425 0.543918 0.0545566 1.23383 0.00365718L1.33333 0H3.33333ZM10.6667 0C11.3696 0 11.9454 0.543918 11.9963 1.23383L12 1.33333V10.6667C12 11.3696 11.4561 11.9454 10.7662 11.9963L10.6667 12H4.66667V0H10.6667Z",
		fill: "currentColor"
	})
});
export default SvgLayoutLeftFill;
